import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=99194918&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=99194918&prod&lang=scss"
import style1 from "./ProductImage.vue?vue&type=style&index=1&id=99194918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99194918",
  null
  
)

export default component.exports